import { useEffect, useState } from 'react';
// Listeners who can't take bookings (Sam, Oct 15) — fetched once per page load, shared by every list.
let hidden = null;
let pending = null;
const subs = new Set();
const load = () => {
  if (hidden || pending || typeof fetch !== 'function' || typeof window === 'undefined') return;
  pending = fetch('/api/listeners-hidden', { credentials: 'same-origin' })
    .then(r => (r.ok ? r.json() : { hidden: [] }))
    .then(j => {
      hidden = new Set(Array.isArray(j?.hidden) ? j.hidden : []);
      subs.forEach(f => f(hidden));
    })
    .catch(() => {
      hidden = new Set();
      subs.forEach(f => f(hidden));
    });
};
export const useHiddenListingIds = () => {
  const [set, setSet] = useState(hidden || new Set());
  useEffect(() => {
    subs.add(setSet);
    load();
    if (hidden) setSet(hidden);
    return () => subs.delete(setSet);
  }, []);
  return set;
};
export const withoutHidden = (listings, set) =>
  set && set.size ? (listings || []).filter(l => !set.has(l?.id?.uuid)) : listings || [];
